import {createLazyLoadTrigger} from "@/laraberg_frontend/general"

// Function to initialize the quote slider
const quoteSlider = function (element) {
    return {
        element: element,

        async init() {
            // Function to wrap an element inside a new wrapper div
            function wrap(el, wrapper) {
                el.parentNode.insertBefore(wrapper, el)
                wrapper.appendChild(el)
            }

            // Dynamically import Swiper and its modules
            const [{default: Swiper}, {Navigation, Pagination}] = await Promise.all([
                import("swiper"),               // Import Swiper module
                import("swiper/modules")         // Import Swiper's navigation and pagination modules
            ])

            // Register the necessary Swiper modules
            Swiper.use([Navigation, Pagination])

            // Prepare pagination for each quote slider
            const sliders = document.querySelectorAll(".wp-block-tutkit-quote-slider")
            sliders.forEach((slider) => {
                const pagination = document.createElement("div")
                pagination.className = "swiper-pagination"
                slider.append(pagination)
            })

            // Handling quotes with and without images, wrapping them into Swiper slides
            const tutkitQuote = document.querySelectorAll(".wp-block-tutkit-quote-slider .wp-block-tutkit-quote")
            const tutkitQuoteWithoutImg = document.querySelectorAll(".wp-block-tutkit-quote-slider .wp-block-tutkit-quote-without-img")

            // Wrap quotes with images in Swiper slides
            if (tutkitQuote.length > 0) {
                tutkitQuote.forEach((quote) => {
                    const div = document.createElement("div")
                    div.className = "swiper-slide"
                    wrap(quote, div)
                })
            }

            // Wrap quotes without images in Swiper slides
            if (tutkitQuoteWithoutImg.length > 0) {
                tutkitQuoteWithoutImg.forEach((quote) => {
                    const div = document.createElement("div")
                    div.className = "swiper-slide"
                    wrap(quote, div)
                })
            }

            // Initialize Swiper for the current slider
            new Swiper(`.wp-block-tutkit-quote-slider .swiper`, {
                speed: 1000,
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                autoHeight: true,
                navigation: {
                    nextEl: `.swiper-button-next`,
                    prevEl: `.swiper-button-prev`
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            })
        }
    }
}

// Function to initialize all quote sliders with lazy loading
function initQuoteSliders() {
    const sliders = document.querySelectorAll(".wp-block-tutkit-quote-slider")
    if (!sliders.length) return

    // Lazy load the sliders when they come into view
    createLazyLoadTrigger(".wp-block-tutkit-quote-slider", 200, () => {
        sliders.forEach((slider) => {
            quoteSlider(slider).init() // Initialize each slider when necessary
        })
    })
}

// Check document ready state and initialize the quote sliders
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initQuoteSliders)
} else {
    initQuoteSliders()
}
